import React, { Suspense } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

import useRegion from '../../hooks/useRegion';
import useSelector from '../../hooks/useSelector';
import { StyledModalHeader } from '../../modules/User/FavoriteStockFloatingButton';
import LoadingImage from '../general/LoadingImage';
import {
  generateRadarChartData,
  RANKS,
} from '../visualize/WinPercentageCardUtils';
import TipsTemporalTable from './TipsTemporalTable';

const WinPercentageCardLazy = React.lazy(
  () => import('../visualize/WinPercentageCard')
);

const WinPercentageModal: React.FC<{
  show: boolean;
  onHide: () => void;
  influencerName: string;
}> = ({ show, onHide, influencerName }) => {
  const [t] = useTranslation();

  const region = useRegion();
  const { loading, influencerRanks, influencerTips } = useSelector(
    state => state.tips.loadInfluencerWinRates
  );

  const winPercentageData =
    influencerRanks && influencerRanks.influencerPercentageRanks
      ? influencerRanks.influencerPercentageRanks.map(item =>
          RANKS.indexOf(item)
        )
      : [];
  const winRateData =
    influencerRanks && influencerRanks.influencerRateRanks
      ? influencerRanks.influencerRateRanks.map(item => RANKS.indexOf(item))
      : [];

  const data = generateRadarChartData(t, winRateData, winPercentageData);

  return (
    <Modal show={show} centered onHide={onHide} size="xl">
      <Modal.Body>
        <div>
          <StyledModalHeader closeButton>
            <Modal.Title style={{ fontSize: 18, padding: 0, marginTop: 0 }}>
              {influencerName + ' - ' + t(`tips-win-analyse-${region}`)}
              <LoadingImage loading={loading} />
            </Modal.Title>
          </StyledModalHeader>
          <Suspense fallback={<LoadingImage loading displayAsBlock />}>
            <WinPercentageCardLazy
              t={t}
              ranks={influencerRanks}
              data={data}
              note={`* ${t('tips-win-percentage-note')}`}
              winPercentageKey="influencerPercentagesRaw"
              winRateKey="influencerRatesRaw"
            />
          </Suspense>
          <StyledModalHeader>
            <Modal.Title style={{ fontSize: 18, padding: 0, marginTop: 0 }}>
              {t('tips-history')}
              <LoadingImage loading={loading} />
            </Modal.Title>
          </StyledModalHeader>
          <TipsTemporalTable
            data={influencerTips}
            noDataMessage={t(`no-tips-history-${region}`)}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WinPercentageModal;
